import { SvelteMap, SvelteSet } from "svelte/reactivity";
const storageKeyPrefix = "proposal_filters_";
export class FilteredProposals {
    _canisterId;
    // A map of messageId to boolean where true==collapsed
    _messageState;
    _filters;
    constructor(canisterId) {
        this._canisterId = canisterId;
        this._messageState = new Map();
        this._filters = new Set();
    }
    static fromStorage(canisterId) {
        const filteredProposals = new FilteredProposals(canisterId);
        const json = localStorage.getItem(storageKeyPrefix + canisterId);
        filteredProposals._filters = new SvelteSet(json !== null ? JSON.parse(json) : []);
        return filteredProposals;
    }
    get filters() {
        return this._filters;
    }
    hasFilter(topic) {
        return this._filters.has(topic);
    }
    isCollapsed(messageId, proposal) {
        const topic = proposal.kind === "nns" ? proposal.topic : proposal.action;
        const isFiltered = this._filters.has(topic);
        const messageState = this._messageState.get(messageId);
        return messageState ?? isFiltered;
    }
    toggleFilter(topic) {
        if (this._filters.has(topic)) {
            this._filters.delete(topic);
        }
        else {
            this._filters.add(topic);
        }
        // Clear all toggled messages when any filter changes.
        // TODO: Can improve by only clearing those messages that match the changed topic
        this._messageState = new SvelteMap();
        this.toStorage();
    }
    enableAll() {
        this._filters = new SvelteSet();
        this.toStorage();
    }
    disableAll(ids) {
        this._filters = new SvelteSet(ids);
        this.toStorage();
    }
    toggleMessageExpansion(messageId, expand) {
        const currState = this._messageState.get(messageId);
        if (currState === undefined) {
            this._messageState.set(messageId, !expand);
        }
        else if (currState == expand) {
            this._messageState.delete(messageId);
        }
    }
    clone() {
        const clone = new FilteredProposals(this._canisterId);
        clone._messageState = new Map(this._messageState);
        clone._filters = new Set(this._filters);
        return clone;
    }
    toStorage() {
        localStorage.setItem(storageKeyPrefix + this._canisterId, JSON.stringify(Array.from(this._filters)));
    }
}
